var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVisibilityOffDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3519_68904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2152 5.78227C14.868 5.51305 14.4752 5.23169 14.0455 4.95891L16.1949 2.77901C16.4892 2.48062 16.4858 2.00018 16.1874 1.70596C15.889 1.41175 15.4086 1.41507 15.1144 1.7135L12.6677 4.19488C11.565 3.67237 10.3161 3.29559 9.007 3.29559L8.96001 3.29573C6.48158 3.31323 4.21859 4.7152 2.75658 5.88822C1.31041 7.04857 -0.00345507 8.55136 6.82603e-06 9.0412C0.00389553 9.59614 1.27953 11.0441 2.7855 12.2029C3.10068 12.4455 3.50031 12.7315 3.96516 13.021L1.79592 15.2211C1.50171 15.5194 1.50508 15.9999 1.80351 16.2941C1.95133 16.4399 2.14377 16.5126 2.33622 16.5126C2.53217 16.5126 2.72808 16.4371 2.87656 16.2866L5.35252 13.7755C6.42742 14.2751 7.68105 14.6599 8.99235 14.6599L9.04011 14.6598C11.6733 14.6412 14.0563 13.068 15.2425 12.1318C16.7412 10.949 18.004 9.47559 18.0001 8.91439C17.9964 8.39335 16.695 6.92977 15.2152 5.78227ZM5.27888 9.00397C5.26441 6.94884 6.91868 5.2711 8.97376 5.25663C9.73135 5.25128 10.4372 5.47331 11.0279 5.85801L5.90908 11.0494C5.51618 10.4643 5.28423 9.76155 5.27888 9.00397ZM9.02626 12.6989C8.27773 12.7041 7.57985 12.4873 6.99356 12.111L12.1047 6.92726C12.4891 7.50819 12.7158 8.20294 12.7211 8.95147C12.7356 11.0067 11.0813 12.6844 9.02626 12.6989Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3519_68904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityOffDark);
export default __webpack_public_path__ + "static/media/ic_visibility_off_dark.b1c9095b485fe649bb06c081752da888.svg";
export { ForwardRef as ReactComponent };